// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tbo-page-content{position:relative;height:calc(100% - 64px - var(--sc-spacing-3))}
`, "",{"version":3,"sources":["webpack://./src/views/TboPage.vue"],"names":[],"mappings":"AAGA,kBACE,iBAAkB,CAClB,8CAA4D","sourcesContent":["\n$footer-height: 64px;\n\n.tbo-page-content {\n  position: relative;\n  height: calc(100% - #{$footer-height} - var(--sc-spacing-3));\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
